(function () {
    'use strict';
    var elements = document.querySelectorAll('.beano-pie-throwing');

    function checkVisible() {
        var windowHeight = window.innerHeight;
        var windowTop = window.scrollY || window.pageYOffset;
        var windowBottom = windowTop + windowHeight;

        elements.forEach(function (el) {
            var elementHeight = el.offsetHeight;
            var elementTop = el.getBoundingClientRect().top + windowTop;
            var elementBottom = elementTop + elementHeight;

            if ((elementTop + (windowHeight / 4) <= windowBottom)) {
                el.classList.add('is-visible');
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        elements = document.querySelectorAll('.beano-pie-throwing');
        window.addEventListener('scroll', checkVisible);
        window.addEventListener('resize', checkVisible);

        setTimeout(function () { checkVisible(); }, 200);
    });
})();


